"use client";

import React from "react";
import {
  TrendingDown,
  Shield,
  Award,
  ArrowRight,
  Star,
  CheckCircle,
} from "lucide-react";

const GuitarCuCTASection = () => {
  return (
    <section className="bg-black py-12 md:py-16 px-4">
      <div className="max-w-7xl mx-auto">

        <div className="grid lg:grid-cols-2 gap-10 items-center mb-8">

          {/* LEFT CONTENT */}
          <div>
            <div className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 rounded-full text-xs sm:text-sm font-bold mb-4">
              <TrendingDown className="w-4 h-4" />
              <span>GUITAR CŨ GIÁ TỐT TPHCM</span>
            </div>

            <h2 className="text-xl md:text-4xl lg:text-5xl font-black text-foreground mb-4 leading-tight">
              <span className="block">GUITAR CŨ –</span>
              <span className="block text-primary">
                GUITAR ĐÃ QUA SỬ DỤNG
              </span>
              <span className="block">TẠI QUẬN 12, TPHCM</span>
            </h2>

            <p className="text-sm sm:text-lg text-muted-foreground mb-6 leading-relaxed">
              <strong>Guitar Sài Gòn</strong> chuyên cung cấp <strong>guitar cũ</strong> và
              <strong> guitar đã qua sử dụng</strong> chất lượng cao tại <strong>Quận 12</strong>.
              Nếu bạn đang tìm nơi <strong>mua guitar ở TPHCM</strong> hoặc
              <strong> mua guitar ở Sài Gòn</strong> với giá hợp lý, đây là lựa chọn phù hợp.
              Ngoài ra còn có <strong>khóa học guitar</strong> dành cho người mới bắt đầu đến nâng cao.
            </p>

            {/* USP */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              {[
                {
                  title: "Guitar chính hãng",
                  desc: "Yamaha, Fender, Taylor",
                },
                {
                  title: "Kiểm tra kỹ trước khi bán",
                  desc: "Đảm bảo âm thanh & ngoại hình",
                },
                {
                  title: "Hỗ trợ người mới",
                  desc: "Tư vấn chọn đàn phù hợp",
                },
                {
                  title: "Học trực tiếp tại Quận 12",
                  desc: "Khóa học guitar thực tế",
                },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <div>
                    <div className="font-semibold text-foreground text-sm">
                      {item.title}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {item.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* MAIN CTA */}
            <a
              href="/guitar-cu"
              className="inline-flex items-center justify-center gap-3 bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-4 rounded-xl font-bold text-lg shadow-md hover:shadow-lg transition-all duration-200 scale-80 sm:scale-100 "
            >
              <span>Mua Guitar Cũ Ở Quận 12</span>
              <ArrowRight className="w-5 h-5" />
            </a>

            <div className="flex flex-wrap items-center gap-4 mt-6 text-sm text-muted-foreground">
              <div className="flex items-center gap-1">
                <Star className="w-4 h-4 text-primary fill-current" />
                <span>Guitar cũ chất lượng</span>
              </div>
              <div className="flex items-center gap-1">
                <Award className="w-4 h-4 text-primary" />
                <span>Địa điểm mua guitar ở Sài Gòn</span>
              </div>
            </div>
          </div>

          {/* RIGHT CARD */}
          <div className="relative">
            <div className="relative bg-background rounded-3xl shadow-lg p-8 border border-border">
              <h3 className="text-base sm:text-2xl font-bold text-foreground mb-6 text-center">
                Mua Guitar Ở TPHCM – Quận 12
              </h3>

              <div className="space-y-4 mb-6 text-sm sm:text-base">
                {[
                  {
                    icon: <TrendingDown className="w-4 h-6 sm:w-6 sm:h-6 text-primary" />,
                    title: "Guitar Cũ Giá Tốt",
                    desc: "Phù hợp học tập và giải trí",
                  },
                  {
                    icon: <Shield className="w-4 h-6 sm:w-6 sm:h-6 text-primary" />,
                    title: "Guitar Đã Qua Sử Dụng",
                    desc: "Âm thanh ổn định, kiểm tra kỹ",
                  },
                  {
                    icon: <Award className="w-4 h-6 sm:w-6 sm:h-6 text-primary" />,
                    title: "Khóa Học Guitar",
                    desc: "Dành cho người mới tại Quận 12",
                  },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="flex items-start gap-4 p-4 bg-muted/40 rounded-xl border border-border hover:border-primary/40 transition-all "
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                      {item.icon}
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-foreground mb-1">
                        {item.title}
                      </h4>
                      <p className="text-sm text-muted-foreground">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href="/dang-ky-hoc-guitar"
                className="block text-center bg-primary text-primary-foreground py-3 rounded-xl font-bold hover:bg-primary/90 transition-colors"
              >
                Đăng Ký Khóa Học Guitar
              </a>
            </div>
          </div>
        </div>

        {/* SEO TEXT BLOCK */}
        <div className="mt-8 text-sm text-muted-foreground leading-relaxed">
          <p>
            Nếu bạn đang tìm <strong>mua guitar ở TPHCM</strong>,
            <strong> mua guitar ở Quận 12</strong> hoặc
            <strong> mua guitar ở Sài Gòn</strong>,
            Guitar Sài Gòn cung cấp đa dạng <strong>guitar cũ</strong> và
            <strong> guitar đã qua sử dụng</strong> phù hợp cho người mới học đến người chơi nâng cao.
            Bên cạnh đó còn có <strong>khóa học guitar</strong> thực hành trực tiếp tại Quận 12
            giúp bạn học đúng kỹ thuật và tiến bộ nhanh.
          </p>
        </div>

      </div>
    </section>
  );
};

export default GuitarCuCTASection;